import { render } from "./Top10ProductsChart.vue?vue&type=template&id=bd60a7be"
import script from "./Top10ProductsChart.vue?vue&type=script&lang=js"
export * from "./Top10ProductsChart.vue?vue&type=script&lang=js"

import "./Top10ProductsChart.vue?vue&type=style&index=0&id=bd60a7be&lang=css"

import exportComponent from "C:\\Users\\msimi\\Downloads\\tuaszone\\survey-agel-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__